// @flow

import * as React from 'react';

const DEFAULT_TITLE = 'The best apps. Better together.';
const DEFAULT_SECONDARY_TITLE = ' | Zapier';

type Props = {
  children?: React.Node,
  secondaryTitle?: string,
  title?: string,
};

const setTitle = (props: Props) => {
  const primaryTitle = props.title || DEFAULT_TITLE;
  const secondaryTitle = props.secondaryTitle || DEFAULT_SECONDARY_TITLE;

  document.title = `${primaryTitle}${secondaryTitle}`;
};

class Document extends React.Component<Props> {
  componentDidMount() {
    setTitle(this.props);
  }

  componentDidUpdate() {
    setTitle(this.props);
  }

  componentWillUnmount() {
    setTitle({});
  }

  render() {
    return this.props.children || null;
  }
}

export default Document;
